import {
  GetSectionPostOptionsProps,
  PostOption,
  SectionPostOptions,
} from '../../../helpers/types'

/* getCarouselLinkAdModule takes a post component's post options and converts them to a dynamic module Component */
export const getCarouselLinkAdModule = ({
  module,
}: GetSectionPostOptionsProps): SectionPostOptions => {
  let ctaUrl = module?.igCarouselAdWebsiteUrlOption
  if (typeof ctaUrl === 'object')
    ctaUrl = (module?.igCarouselAdWebsiteUrlOption as PostOption)?.content
  if (!ctaUrl) ctaUrl = ''

  return {
    ctaUrl: ctaUrl,
    headline: module?.igCarouselAdHeadline || '',
  }
}
